export default "__VITE_ASSET__DMlnWlD3__"